import { render, staticRenderFns } from "./mini_program.vue?vue&type=template&id=92fbb450&scoped=true&"
import script from "./mini_program.vue?vue&type=script&lang=js&"
export * from "./mini_program.vue?vue&type=script&lang=js&"
import style0 from "./mini_program.vue?vue&type=style&index=0&id=92fbb450&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "92fbb450",
  null
  
)

export default component.exports